// extracted by mini-css-extract-plugin
module.exports = {"legends":"Legends_legends__XCcy4","content":"Legends_content__1MPKy"};